import {jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {lazy} from 'react'
import { Navigate, Route, Routes, useLocation} from 'react-router'
import useAuthRoute from '../hooks/useAuthRoute'
import useNoIndex from '../hooks/useNoIndex'

const Graphql = lazy(
  () =>
    import(
      /* webpackChunkName: 'GraphqlContainer' */ '../modules/admin/containers/Graphql/GraphqlContainer'
    )
)
const Impersonate = lazy(
  () =>
    import(
      /* webpackChunkName: 'ImpersonateContainer' */ '../modules/admin/containers/Impersonate/ImpersonateContainer'
    )
)
const Signout = lazy(
  () => import(/* webpackChunkName: 'SignoutContainer' */ '../containers/Signout/SignoutContainer')
)
const DashboardRoot = lazy(() => import(/* webpackChunkName: 'DashboardRoot' */ './DashboardRoot'))
const MeetingRoot = lazy(() => import(/* webpackChunkName: 'MeetingRoot' */ './MeetingRoot'))
const MeetingSeriesAttendRedirect = lazy(
  () =>
    import(/* webpackChunkName: 'MeetingSeriesAttendRedirect' */ './MeetingSeriesAttendRedirect')
)
const MeetingSeriesManagementRoot = lazy(
  () =>
    import(/* webpackChunkName: 'MeetingSeriesManagementRoot' */ './MeetingSeriesManagementRoot')
)
const ViewerNotOnTeamRoot = lazy(
  () => import(/* webpackChunkName: 'ViewerNotOnTeamRoot' */ './ViewerNotOnTeamRoot')
)

const ActivityLibraryRoutes = lazy(
  () =>
    import(
      /* webpackChunkName: 'ActivityLibraryRoutes' */ './ActivityLibrary/ActivityLibraryRoutes'
    )
)

const ReviewRequestToJoinOrgRoot = lazy(
  () => import(/* webpackChunkName: 'ReviewRequestToJoinOrgRoot' */ './ReviewRequestToJoinOrgRoot')
)
const NotFound = lazy(() => import(/* webpackChunkName: 'NotFound' */ './NotFound/NotFound'))

const DASHBOARD_PREFIXES = ['/meetings', '/me', '/new-summary', '/newteam', '/team', '/pages']

const DashboardOrNotFound = () => {
  const {pathname} = useLocation()
  const isDashboardRoute = DASHBOARD_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + '/')
  )
  if (!isDashboardRoute) return _jsx(NotFound, {} )
  return _jsx(DashboardRoot, {} )
}

const PrivateRoutes = () => {
  useAuthRoute()
  useNoIndex()
  const location = useLocation()
  const state = location.state 
  return (
    _jsxs(_Fragment, { children: [
      _jsxs(Routes, { location: _optionalChain([state, 'optionalAccess', _ => _.backgroundLocation]) || location, children: [
        _jsx(Route, { path: "/activity-library/*", element: _jsx(ActivityLibraryRoutes, {} ),} )
        , _jsx(Route, { path: "/new-meeting", element: _jsx(Navigate, { to: "/activity-library", replace: true,} ),} )
        , _jsx(Route, { path: "/meet/:meetingId/*", element: _jsx(MeetingRoot, {} ),} )
        , _jsx(Route, {
          path: "/meeting-series/manage/:meetingSeriesId",
          element: _jsx(MeetingSeriesManagementRoot, {} ),}
        )
        , _jsx(Route, { path: "/meeting-series/:slug", element: _jsx(MeetingSeriesAttendRedirect, {} ),} )
        , _jsx(Route, { path: "/admin/graphql", element: _jsx(Graphql, {} ),} )
        , _jsx(Route, { path: "/graphql", element: _jsx(Graphql, {} ),} )
        , _jsx(Route, { path: "/admin/impersonate", element: _jsx(Impersonate, {} ),} )
        , _jsx(Route, { path: "/invitation-required", element: _jsx(ViewerNotOnTeamRoot, {} ),} )
        , _jsx(Route, { path: "/signout", element: _jsx(Signout, {} ),} )
        , _jsx(Route, { path: "*", element: _jsx(DashboardOrNotFound, {} ),} )
      ]})
      , _jsx(Routes, { children: 
        _jsx(Route, {
          path: "/organization-join-request/:requestId",
          element: _jsx(ReviewRequestToJoinOrgRoot, {} ),}
        )
      })
    ]})
  )
}

export default PrivateRoutes
